import { connect } from 'react-redux';
import TableAsal from '../../../views/Library/TableAsal/TableAsal.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(TableAsal);
